module.exports = __webpack_public_path__ + "static/media/CYROTH.e5cd72e1.png";